import React, {useState, useContext, useRef, useEffect} from 'react'
import { IonInput, IonButton, IonItem, IonList,IonGrid, IonRow, IonCol, IonModal, IonContent } from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';

//import { Plugins } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences'
import Cookie from 'universal-cookie';



import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { UpdatePassword } from './Modal_Update_Password';

import '../css/zPublic.css';


async function setMessengeSID_Twilio(event) {

    Preferences.set({
        key: 'twilio_message_sid',
        value: event[0],
    })
}


export function Reset_Password_Modal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    let [acctID, setAccountID ] = useState(null);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [disableVerifyButton, setDisableVerifyButton] = useState(false);
    let [disableOTPButton, setDisableOTPButton] = useState(false);
    let [disableOTPButton_resend, setDisableOTPButton_resend] = useState(false);

    let [updatePasswordModal, setUpdatePasswordModal] = useState(false);

    let [userPhoneNumber, setUserPhoneNumber] = useState(null);
    let [userCountry, setUserCountry] = useState(null);

    let [messageStatus, setMessageStatus] = useState(null);

    let usernameRef = useRef(''); 
    let otpRef = useRef('');


    useEffect(() => {

        //alert("IN USE EFFECT");
        //alert(props.openModal);

        if(props.openModal == true)
        {
            //alert("IN USE EFFECT 2");
            //alert(usernameRef.current.value);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 'update_password_check_status_initial',
                xUsername: usernameRef.current.value
                //user: acctID,
                //sessionID: sessionID,

            }),
        }

        //alert("IN USE EFFECT 3");

        fetch(baseURL+'reset_password_status', requestOptions)
        .then(res => res.json())
        .then(data => {
            //alert("In USEEFFECT Search MessagerID");

            //alert(data);

            let cols = data;//[0].split('|');
            setUserPhoneNumber(cols[1]);
            setUserCountry(cols[2])

            if(data[5].status == 'delivered')
            {

                alert("ONE-TIME-PASSWORD DELIVERED");

                setMessageStatus('delivered');
                setDisableOTPButton(true);
                setDisableOTPButton_resend(false);

            }
            else if(cols[3]== '' || data[5].status == 'undelivered')
            {

                setDisableOTPButton(false);
                setDisableOTPButton_resend(true);

            }
            else if(data[5].status == 'sending' || data[5].status == 'sent')
            {

                alert("ONE-TIME-PASSWORD SENDING OR SENT");

                setMessageStatus('delivered');
                setDisableOTPButton(true);
                setDisableOTPButton_resend(false);

            }
            else
            {

                setDisableOTPButton(false);
                setDisableOTPButton_resend(true);

            }
        })
    }
}, [props.openModal]);


    function getOTP() {


        setDisableOTPButton(true);
        setDisableOTPButton_resend(true);
        

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 'reset_password',
                //user: acctID,
                xUsername: usernameRef.current.value,
                xUserPhoneNumber: userPhoneNumber,
                xUserCountry: userCountry

            })
        }

        

        fetch(baseURL+'reset_password', requestOptions)
        .then(res => res.json())
        .then(data => {

            
            if (data == 'no_twilio_sid')
            {
                setDisableOTPButton(false);
                setDisableOTPButton_resend(true);
            }
            else if(data.status == 'delivered')
            {

                alert("ONE-TIME-PASSWORD DELIVERED");

                setMessageStatus('delivered');
                setDisableOTPButton(true);
                setDisableOTPButton_resend(true);

            }
            else if(data.status == 'sending' || data.status == 'sent')
            {

                alert("ONE-TIME-PASSWORD SENT");

                setMessageStatus('delivered');
                setDisableOTPButton(true);
                setDisableOTPButton_resend(true);

            }
            else
            {
                alert("ONE-TIME-PASSWORD NOT DELIVERED");

                setDisableOTPButton(false);
                setDisableOTPButton_resend(false);

            }
           // props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })

    }

    function verifyOTP() {

        setDisableVerifyButton(true);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 'verify_otp',
                //user: acctID,
                xUsername: usernameRef.current.value,
                xOTP: otpRef.current.value
            })
        }

        

        fetch(baseURL+'reset_password', requestOptions)
        .then(res => res.json())
        .then(data => {

            //alert(data);
            let cols = data.toString();
            //alert(cols);

            if(cols == "otp_confirmed")
            {

                alert("INSIDE OTP_CONFIRMED");
                setUpdatePasswordModal(true);
                setDisableVerifyButton(false);
            }
            else
            {
                alert("OUTSIDE OTP_CONFIRMED");

                setDisableVerifyButton(false);
            }
           // props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })

    }

    function searchMessengerID() {

                    //alert("IN USE EFFECT A");
                    //alert(props.openModal);


                        //alert("IN USE EFFECT B");
                        //alert(usernameRef.current.value);

                    const requestOptions = {
                        method: 'POST',
                        //credentials: 'include',
                        headers: {
                            'Accept': 'text/html, application/json',
                            'content-type': 'application/json',
                            //'cookie': 'cookie',
                        },
                        body: JSON.stringify({
                            Tracker: 'update_password_check_status_initial',
                            xUsername: usernameRef.current.value
                            //user: acctID,
                            //sessionID: sessionID,

                        }),
                    }

                    //alert("IN USE EFFECT C");

                    fetch(baseURL+'reset_password_status', requestOptions)
                    .then(res => res.json())
                    .then(data => {

                        //alert(data);

                        let cols = data;//[0].split('|');
                        setUserPhoneNumber(cols[1]);
                        setUserCountry(cols[2])

                        if(data[5].status == 'delivered')
                        {
            
                            alert("ONE-TIME-PASSWORD DELIVERED");
            
                            setMessageStatus('delivered');
                            setDisableOTPButton(true);
                            setDisableOTPButton_resend(false);

                        }
                        else if(data[5].status == 'sending' || data[5].status == 'sent')
                        {
            
                            alert("ONE-TIME-PASSWORD SENDING OR SENT");
            
                            setMessageStatus('delivered');
                            setDisableOTPButton(true);
                            setDisableOTPButton_resend(false);

                        }
                        else if(cols[3]== '' || data[5].status == 'undelivered')
                        {
                            alert("ONE-TIME-PASSWOR BLANK OR UNDELIVERED");

                            setMessageStatus('delivered');
                            setDisableOTPButton(false);
                            setDisableOTPButton_resend(true);

                        }
                        else
                        {
            
                            setDisableOTPButton(false);
                            setDisableOTPButton_resend(true);

                        }
                    })
    }

    function closeModalHandler() {

        setUpdatePasswordModal(false);
        props.closeModal(false);
    }

    let timeout;

    function handleInput(event) {

        clearTimeout(timeout); // Clear the previous timeout to reset the delay
        timeout = setTimeout(searchMessengerID(event), 8000); // Set a new timeout
    
    }
    //alert('in LoginCredential_merchant');
    //alert(landingPage)

    return (
    

        <React.Fragment>
                {
                props.openModal == true ?
                (
                <IonModal isOpen={ props.openModal }>

                        <IonGrid className='appGridRow_Content'>
                            <IonRow >
                                <IonCol size='6'>
                                    <input type='text'  id='searchSupplierName'  placeholder="Enter Username" ref={ usernameRef  } onInput={() => handleInput(['name', usernameRef.current.value])} ></input>
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'>
                                    {/*<button onClick={handleConfirmEmployeeLogin}>Login</button>*/}
                                    <IonButton onClick={() => getOTP()} disabled={disableOTPButton}>GET OTP</IonButton>
                                    <IonButton onClick={() => getOTP()} disabled={disableOTPButton_resend}>Resend OTP</IonButton>

                                </IonCol>
                            </IonRow>
                            {messageStatus == 'delivered' && 
                                <IonRow >
                                    <IonCol size='6'>
                                        <IonInput type='text' placeholder="Enter ONE-TIME-PASSWORD" ref={ otpRef }></IonInput>
                                    </IonCol>
                                </IonRow>}
                            {messageStatus == 'delivered' && 
                                <IonRow>
                                    <IonCol>
                                        <IonButton onClick={() => verifyOTP()} disabled={disableVerifyButton}>Submit</IonButton>
                                   </IonCol>
                                </IonRow>}
                        </IonGrid>

                        {updatePasswordModal == true && <UpdatePassword  openModal={ updatePasswordModal } closeModal={closeModalHandler} data={{
                                        username: usernameRef.current.value, 
                                        }}></UpdatePassword>}


                    <IonButton onClick={() => props.closeModal(false)}>Close</IonButton>
                    </IonModal>) : null
                }

        </React.Fragment>  
    )
     
}